module.exports = __webpack_public_path__ + "img/orderFlowHeader.d989e4f4.png";